var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M11.737 15.13a.54.54 0 0 1-.25-.06l-4.02-1.993-4.018 1.992a.56.56 0 0 1-.806-.584l.656-4.438L.16 6.84a.55.55 0 0 1-.13-.566.57.57 0 0 1 .441-.382l4.423-.749 2.08-3.974a.564.564 0 0 1 .995 0l2.08 3.974 4.422.75a.562.562 0 0 1 .311.947l-3.138 3.206.655 4.438a.564.564 0 0 1-.554.645zm-4.266-3.24c.086 0 .173.018.251.06l3.304 1.64-.54-3.652a.56.56 0 0 1 .154-.475l2.58-2.637-3.636-.614a.57.57 0 0 1-.405-.293L7.471 2.65 5.763 5.92a.55.55 0 0 1-.404.293l-3.637.614 2.58 2.637c.124.123.18.3.154.475l-.54 3.652 3.304-1.64a.6.6 0 0 1 .251-.06"
  })));
};
export default Svg2;